import { api } from "services/api";
import processCampaigns from "utils/campaigns/processCampaigns";

export const loadCampaigns = () => async (dispatch) => {
  dispatch({ type: "CAMPAIGNS_LOADING" });

  try {
    const { data: payload } = await api.get("/campaigns-data/few");

    const campaigns = processCampaigns(payload);
    return dispatch({ type: "CAMPAIGNS_LOAD", payload: campaigns });
  } catch (err) {
    //todo handle this
    console.log(err);
  }

  return dispatch({ type: "CAMPAIGNS_FAILED" });
};

export const a = "b";
